<template>
  <section class="hd-feat" aria-labelledby="hazte-duena-features-title">
    <h2 id="hazte-duena-features-title" class="wd-title">
      <span class="hl">Características</span> <span class="hd-feat__base">generales</span>
    </h2>

    <ul class="hd-feat__grid">
      <li v-for="feature in features" :key="feature.title" class="hd-feat__card">
        <div class="hd-feat__head">
          <img :src="feature.icon" alt="" aria-hidden="true">
          <h3 class="hd-feat__title">{{ feature.title }}</h3>
        </div>
        <p class="wd-body" v-html="feature.description" />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import homeIcon from '../../../assets/hazte-duena-figma/ic-home.svg'
import agentIcon from '../../../assets/hazte-duena-figma/ic-agent.svg'
import paymentsIcon from '../../../assets/hazte-duena-figma/ic-payments.svg'
import folderIcon from '../../../assets/hazte-duena-figma/ic-folder.svg'
import gymnasticsIcon from '../../../assets/hazte-duena-figma/ic-gymnastics.svg'

const features = [
  {
    icon: homeIcon,
    title: 'Tipo de vivienda',
    description: 'Inmuebles en zona urbana/semiurbana con servicios y situación legal correcta.'
  },
  {
    icon: agentIcon,
    title: 'Comprador',
    description: 'Mujeres con ingresos de Nómina, Negocio Propio, Actividad Independiente, Comisiones, Rentas, Inversiones.'
  },
  {
    icon: paymentsIcon,
    title: 'Validación financiera',
    description: 'Revisión de historial, capacidad <br class="br-tm">de pago y endeudamiento <br class="br-tm">(Buró de crédito).'
  },
  {
    icon: folderIcon,
    title: 'Expediente',
    description: 'Integración documental <br>de ingresos y validación <br>del inmueble.'
  },
  {
    icon: gymnasticsIcon,
    title: 'Flexibilidad inicial',
    description: 'Consideramos diversas formas <br class="br-tm">de comprobar tus ingresos <br class="br-tm">para adaptarnos a tu <br class="br-d br-t">realidad financiera.'
  }
]
</script>

<style scoped>
.hd-feat { display: flex; flex-direction: column; gap: var(--ds-space-7); }
.hd-feat__base { color: var(--ds-purple-900); }
.hd-feat .wd-title { height: 40px; line-height: 44px; }

/* Desktop: 6 columnas; 3 cards en la primera fila y 2 en la segunda con el mismo ancho */
.hd-feat__grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: var(--ds-space-5);
  margin: 0;
  padding: 0;
  list-style: none;
}
.hd-feat__card { grid-column: span 2; }
/* La segunda fila mide 208px de alto en el Figma */
.hd-feat__card:nth-child(n + 4) { min-height: 208px; }

.hd-feat__card {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
  /* El borde de 1px va dentro de las medidas del Figma (24px de padding incluyendo el trazo) */
  padding: calc(var(--ds-space-5) - 1px);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border: 1px solid var(--ds-border-card);
  border-radius: 16px;
}

.hd-feat__head { display: flex; align-items: center; gap: var(--ds-space-4); }
.hd-feat__head img { flex: 0 0 40px; width: 40px; height: 40px; }
.hd-feat__title {
  margin: 0;
  color: var(--ds-text-body);
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
}

@media (max-width: 1024px) {
  .hd-feat__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .hd-feat__card { grid-column: auto; }
  .hd-feat__card:nth-child(n + 4) { min-height: 0; }
}

@media (max-width: 599px) {
  .hd-feat { gap: var(--ds-space-6); }
  .hd-feat__grid { grid-template-columns: minmax(0, 1fr); gap: var(--ds-space-4); }
}
</style>
